<div class="container py-5">
  <div class="row justify-content-center">
    <div class="col-lg-6">
      <div class="card bg-dark text-light p-4">
        <h1 class="h4 mb-3">Accept invite</h1>

        <ng-container [ngSwitch]="status">
          <div *ngSwitchCase="'loading'" class="text-muted">Loading invite…</div>

          <div *ngSwitchCase="'ready'" class="d-grid gap-3">
            <p class="mb-0">You have been invited to join this account as a <strong>{{ invite?.role | titlecase }}</strong>.</p>
            <p class="mb-0 text-muted" *ngIf="invite?.expiresAt">
              This invite expires on {{ formatTimestamp(invite?.expiresAt) | date: 'medium' }}.
            </p>
            <div class="alert alert-info mb-0" *ngIf="!currentUser">
              Sign in or create an account to accept this invite.
            </div>
            <div class="d-flex flex-column flex-sm-row gap-2" *ngIf="currentUser; else authActions">
              <button class="btn btn-primary" type="button" (click)="acceptInvite()">Accept invite</button>
              <button class="btn btn-outline-light" type="button" (click)="rejectInvite()">Reject invite</button>
            </div>
            <ng-template #authActions>
              <div class="d-flex flex-column flex-sm-row gap-2">
                <a class="btn btn-primary" [routerLink]="['/login']" [queryParams]="{ redirectTo: redirectTo }">Sign in</a>
                <a class="btn btn-outline-light" [routerLink]="['/register']" [queryParams]="{ redirectTo: redirectTo }">Create account</a>
              </div>
            </ng-template>
          </div>

          <div *ngSwitchCase="'accepted'" class="alert alert-success mb-0">
            Invite accepted. You can now access this account.
          </div>

          <div *ngSwitchCase="'rejected'" class="alert alert-secondary mb-0">
            Invite rejected. If this was a mistake, ask for a new invite.
          </div>

          <div *ngSwitchCase="'expired'" class="alert alert-warning mb-0">
            This invite has expired. Please request a new invite.
          </div>

          <div *ngSwitchDefault class="alert alert-danger mb-0">
            {{ errorMessage || 'Unable to process invite.' }}
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
